/* eslint-disable max-lines-per-function */
/**
 * Vue-compatible renderList helper. Handles arrays, numbers, objects,
 * strings, and iterables — matching Vue's v-for runtime behavior.
 *
 * Imported by Step 3 (vue-jsx). Removed at Step 7 (to-react) when
 * v-for patterns are converted to plain .map() calls.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function renderList(source: any, renderItem: (...args: any[]) => any): any[] {
  if (Array.isArray(source) || typeof source === "string") {
    const ret = new Array(source.length);
    for (let i = 0; i < source.length; i += 1) {
      ret[i] = renderItem(source[i], i);
    }
    return ret;
  }
  if (typeof source === "number") {
    const ret = new Array(source);
    for (let i = 0; i < source; i += 1) {
      ret[i] = renderItem(i + 1, i);
    }
    return ret;
  }
  if (typeof source === "object" && source !== null) {
    if (source[Symbol.iterator]) {
      return Array.from(source, (item, i) => renderItem(item, i));
    }
    const keys = Object.keys(source);
    const ret = new Array(keys.length);
    for (let i = 0; i < keys.length; i += 1) {
      // @ts-expect-error
      ret[i] = renderItem(source[keys[i]], keys[i], i);
    }
    return ret;
  }
  return [];
}
